import React, { FunctionComponent } from "react";
import { Link } from "gatsby";

export interface Pagination {
  prev?: string;
  next?: string;
}

export const Pagination: FunctionComponent<Pagination> = ({ prev, next }) => (
  <nav className="flex items-center justify-between border-t border-line pt-6">
    <div>
      {prev && (
        <Link to={prev} className="btn-secondary">
          ← Previous
        </Link>
      )}
    </div>
    <div>
      {next && (
        <Link to={next} className="btn-secondary">
          Next →
        </Link>
      )}
    </div>
  </nav>
);
